import objectFitImages from "object-fit-images";
import smoothscroll from "smoothscroll-polyfill";
objectFitImages();
smoothscroll.polyfill();
